<svelte:options runes={true} />

<!-- Global resets (@layer aurora) and .da-root base styles live in entrypoints/theme.css,
     which compiles into the always-loaded theme-*.css bundle. They cannot live here because
     vite-plugin-shopify only preloads CSS one level deep from each entry point, so this
     component's compiled CSS chunk is never loaded on the live Shopify theme. -->
<script lang="ts">
  import type { Snippet } from "svelte";
  import type { ClassValue } from "svelte/elements";
  import { BitsConfig } from "bits-ui";

  interface Props {
    children: Snippet;
    class?: ClassValue;
    as?: string;
  }

  let { children, as = "div", class: className = "" }: Props = $props();
</script>

<svelte:element this={as} class={["da-root", className]}>
  <BitsConfig defaultLocale="en-GB">
    {@render children()}
  </BitsConfig>
</svelte:element>
